import React, { Component } from 'react';
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import HomePage from './pages/home-page/HomePage';
import MenuPage from './pages/menu-page/MenuPage';
import ChampionsPage from './pages/champions-page/ChampionsPage';
import MyPlatePage from './pages/my-plate-page/MyPlatePage';
import Instructions from './pages/instructions/Instructions';
import PrivacyPolicy from './pages/privacy-policy/PrivacyPolicy';
import Game from './game/Game';
import './App.css';
import fb_db from './firebase/firebaseUse'

class App extends Component {
  constructor(props) {
    super(props);
    window.addEventListener('online', this.online_Listener)
    this.state = {
      isMuted: false
    }
  }

  online_Listener = async () => {
    let playerId = localStorage.getItem("id");

    let ls_score = localStorage.getItem('score')
    let fb_score = await fb_db._db.ref("users/" + playerId + "/score").once('value');

    if (ls_score !== fb_score) {
      fb_db._db.ref("users/" + playerId + "/score").set(ls_score);
    }

  }

  settingMute = (val) => {
    this.setState({ isMuted: val })
  }

  render() {
    return (
      <div>
        <Router>
          <Switch>
            <Route exact path="/" component={HomePage} />
            <Route exact path="/menu" component={MenuPage} />
            <Route exact path="/champions" component={ChampionsPage} />
            <Route exact path="/my-plate" component={MyPlatePage} />
            <Route exact path="/game" component={Game} />
            <Route exact path="/instructions" component={Instructions} />
            <Route exact path="/privacy-policy" component={PrivacyPolicy} />
          </Switch>
        </Router>
      </div>
    );
  }
}

export default App;
